export default __webpack_public_path__ + "static/media/Happy Windows IV.ee7b56c9.jpg";